/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Setup_TitleInputs */



/**
* | output |
* | --- |
* | "Secure your account with a passkey" |
*
* @param {Auth_Passkey_Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_passkey_setup_title = /** @type {((inputs?: Auth_Passkey_Setup_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Setup_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sichere dein Konto mit einem Passkey")
	return /** @type {LocalizedString} */ ("Secure your account with a passkey")
});